import { CommonIP } from '@model/ftf-api.model';
import { createAction, props } from '@ngrx/store';

export const loadFavorites = createAction('[Favorites] Load Favorites');

export const loadFavoritesSuccess = createAction('[Favorites] Load Favorites Success', props<{ favorites: CommonIP[] }>());

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadFavoritesFailure = createAction('[Favorites] Load Favorites Failure', props<{ error: any }>());

export const addFavoriteItem = createAction('[Favorites] Add Favorite Item', props<{ favorite: CommonIP }>());

export const addFavoriteItemSuccess = createAction('[Favorites] Add Favorite Item Success', props<{ favorites: CommonIP[] }>());

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addFavoriteItemFailure = createAction('[Favorites] Add Favorite Item Failure', props<{ error: any }>());

export const removeFavoriteItem = createAction('[Favorites] Remove Favorite Item', props<{ favorite: CommonIP }>());

export const removeFavoriteItemSuccess = createAction('[Favorites] Remove Favorite Item Success', props<{ favorites: CommonIP[] }>());

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeFavoriteItemFailure = createAction('[Favorites] Remove Favorite Item Failure', props<{ error: any }>());

export const resetFavoritesState = createAction('[Favorites] Reset Favorites State');
